import { atom } from "recoil";

// 従業員ユーザーId
export const userState = atom({
  key: "userState",
  default: { user_id: null }
});